interface PlaytomicLogoProps {
  className?: string
  hideText?: boolean
  altText?: string
  role?: string
}

function PlaytomicLogo(props: PlaytomicLogoProps) {
  const { className = 'fill-black', hideText, altText, role = 'img' } = props
  const title = altText || 'Playtomic Logo'

  return (
    <svg
      style={{ shapeRendering: 'geometricPrecision' }}
      role={role}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="100%"
      viewBox={`0 0 ${hideText ? 117 : 1028} 172`}
      version="1.1"
      className={className}
    >
      <title>{title}</title>
      <path d="M67.3,1.13H.69V133H37.21v37.87H67.3c27.55,0,50-21.09,50-47V48.14C117.26,22.22,94.85,1.13,67.3,1.13Zm-5.85,158H48.92v-64H61.45Zm44.11-35.3c0,17.63-14.08,32.28-32.4,34.89v-26.1c15.06-1.8,26.9-9.67,32.4-18.58Zm0-37.86c0,17.62-14.09,32.23-32.4,34.84v-26c15.06-1.8,26.9-9.67,32.4-18.58ZM67.3,83.44H37.21V121.3H12.4V12.84H67.3c21.1,0,38.26,15.84,38.26,35.3S88.4,83.44,67.3,83.44Z" />
      {hideText ? null : (
        <>
          <path d="M711.3,44c-23.72,0-38.46,14-38.46,36.52S687.58,117,711.3,117s38.45-14,38.45-36.52S735,44,711.3,44Zm-.11,60.4c-14.88,0-23.77-8.93-23.77-23.88s9-23.88,24-23.88,23.77,8.93,23.77,23.88S726.21,104.36,711.19,104.36Z" />
          <polygon points="646.95 45.59 581.73 45.59 581.48 58.53 607.22 58.53 607.22 115.37 621.39 115.37 621.39 58.53 647.13 58.53 646.95 45.59" />
          <polygon points="851.21 68.92 851.21 115.37 865.28 115.37 865.28 45.59 848.25 45.59 824.9 86.9 801.03 45.59 784.29 45.59 784.29 115.37 798.16 115.37 798.16 68.92 799.76 68.92 799.98 69.3 824.41 111.5 824.76 111.5 849.61 68.92 851.21 68.92" />
          <polygon points="540.23 45.59 518.84 77.06 516.81 77.06 516.58 76.72 495.82 45.59 479.34 45.59 510.64 91.24 510.64 115.37 524.8 115.37 524.8 90.94 524.94 90.74 556.1 45.59 540.23 45.59" />
          <rect x="904.73" y="45.59" width="14.17" height="69.78" />
          <polygon points="305.93 45.59 305.93 115.37 360.25 115.37 360.71 102.42 320.1 102.42 320.1 45.59 305.93 45.59" />
          <path
            shapeRendering="geometricPrecision"
            d="M248.37,45.59H211.55v69.78h14.16V96.12h21.13c17,0,26.74-9.34,26.74-25.62C273.58,54.67,264.39,45.59,248.37,45.59Zm-1.22,37.89H225.71V58.23h21.13c8.21,0,12.37,4.26,12.37,12.68C259.21,78.78,254.7,83.48,247.15,83.48Z"
          />
          <path d="M413.2,45.59,386,115.37h14.46L407,98.46h35.27l6.42,16.91h14.75L436.3,45.59Zm-1.52,40.64,10.57-27.39h4.81l10.46,27.39Z" />
          <path d="M1011.92,91.71c-2.82,8-9.22,12.65-19.94,12.65-14.89,0-23.77-8.93-23.77-23.88s9-23.88,24-23.88c10.32,0,16.85,4.32,19.43,12.84h15.53C1024,54.33,1011.53,44,992.08,44c-23.71,0-38.45,14-38.45,36.52S968.37,117,992.08,117c18.5,0,32.27-10,35.23-25.29Z" />
        </>
      )}
    </svg>
  )
}

export { PlaytomicLogo }
export type { PlaytomicLogoProps }
